module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"placeholder":"曲名/アーティスト名から探す"},"en":{"placeholder":"Find by Song/Artist name"}}')
  delete Component.options._Ctor
}
